import { useSelector } from 'react-redux';
import AutocompleteDropdown from './AutocompleteDropdown';
import AutocompletePopup from './AutocompletePopup';
import AutocompleteInline from './AutocompleteInline';

const AutcompleteComponents = {
  'inline': AutocompleteInline,
  'dropdown': AutocompleteDropdown,
  'popup': AutocompletePopup,
};

const Autocomplete = (props) => {
  /* Selectors */
  const mode = useSelector(({ autocomplete }) => {
    if (autocomplete.mode === 'inline' && autocomplete.containerData.hasTextAfterCursor) {
      return 'popup';
    }

    return autocomplete.mode;
  });

  let Component = () => {};

  if (mode in AutcompleteComponents) {
    Component = AutcompleteComponents[mode];
  }

  return (
    <Component {...props} />
  );
}

export default Autocomplete;